function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.0001 10.345L18.3401 15.995V11.655H10.3401V19.655H18.3401V15.995L24.0001 21.655H20.3401V29.655H28.3401V21.655H24.0001L29.6601 15.995L24.0001 10.345ZM26.8301 16.005L24.0001 13.175L21.1701 16.005L24.0001 18.835L26.8301 16.005ZM16.3401 17.655V13.655H12.3401V17.655H16.3401ZM26.3401 23.655V27.655H22.3401V23.655H26.3401ZM16.3401 27.655V23.655H12.3401V27.655H16.3401ZM10.3401 21.655H18.3401V29.655H10.3401V21.655Z",
  fill: "#979797"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/VariantsIcon.b127d39d.svg";
export { SvgComponent as ReactComponent };